module.exports = __webpack_public_path__ + "img/فولدر-چرمی.d96ee8a2.png";